import { Coins, Loader, Plus } from "lucide-react";

interface ChipProps {
  text: string;
  value: string;
  onClick: () => void;
  loading: boolean;
  compact?: boolean;
}

export const Chip = ({ text, value, onClick, loading, compact = false }: ChipProps) => {
  return (
    <div className="flex items-center">
      <div
        className={`rounded-full flex items-center ${
          compact
            ? 'px-3 py-1.5 gap-1.5'
            : 'pl-4 pr-1.5 py-1.5 gap-3'
        }`}
        style={compact ? {} : {
          background: "white",
          border: "1.5px solid hsl(230 10% 78%)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div className="flex items-center gap-1.5">
          <Coins
            className="w-5 h-5"
            style={{ color: "hsl(40 75% 50%)" }}
          />
          <span
            className="font-bold text-lg tabular-nums leading-none"
            style={{ color: "hsl(230 10% 35%)" }}
          >
            {loading ? (
              <Loader size={16} color="#6569f1" />
            ) : (
              Number(value).toLocaleString()
            )}
          </span>
        </div>
        {!compact && (
          <button
            onClick={onClick}
            className="w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-all hover:shadow-lg"
            style={{
              background: "linear-gradient(135deg, hsl(226 76% 58%), hsl(218 70% 52%))",
              boxShadow: "0 4px 12px hsl(226 76% 52% / 0.25)",
            }}
          >
            <Plus className="w-4 h-4 text-white" />
          </button>
        )}
      </div>
    </div>
  );
};
